// @packages
import candidateProduct from './candidate-product.json';
import product from './product.json';
import schedule from './schedule.json';
import userSession from './userData.json';

export default {
    candidateProduct,
    product,
    schedule,
    userSession
};
